import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ServidorImpressaoExecutorService} from "../../services/servidor-impressao-executor.service";

@Component({
  selector: 'app-modal-gerenciador-jobs-impressao',
  templateUrl: './modal-gerenciador-jobs-impressao.component.html',
  styleUrls: ['./modal-gerenciador-jobs-impressao.component.scss']
})
export class ModalGerenciadorJobsImpressaoComponent implements OnInit{
  @Input() empresa: any = {};
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onFecharModal: any = new EventEmitter();

  servidorSelecionado: any;
  modalServidorAberto = false;
  colapsado = false;
  constructor(    public servidorExecutor: ServidorImpressaoExecutorService) {
  }

  ngOnInit(): void {
  }

  fechar(fechou: boolean = false) {
    this.onFecharModal.emit({ fechou: fechou });
  }

  abraModalServidorImpressao(){
    if(this.servidorExecutor.servidorRegistrado){
      this.servidorSelecionado = { ...this.servidorExecutor.servidorRegistrado };
      this.servidorSelecionado.isServidorLocal = true;

      // retrai o painel ao abrir o modal do servidor
      this.colapsado = true;
      this.modalServidorAberto = true;
    }

  }

  salvouServidor(servidor: any){
    // ao salvar, fecha o modal do servidor e expande novamente
    this.fecharModalServidor();

    if(servidor.id){ ///pegar dados salvos

    }
  }

  fechouModalServidor(result){
    this.fecharModalServidor();
  }

  fecharModalServidor(){
    this.modalServidorAberto = false;
    this.servidorSelecionado = null;
    // volta a expandir quando o modal interno for fechado
    this.colapsado = false;
  }

  alternarColapso(){
    this.colapsado = !this.colapsado;
  }

}
